export default `
<div class="footer-wrapper">
  <div class="grid w890">
    <h2 class="underline">Liked</h2>
    <feed-item item="feedItem" ng-repeat="feedItem in feedStore.feedItems" ng-switch="feedItem.type"></feed-item>
    <ut-load-more (load-more)="feedStore.loadMore()" [is-loading]="feedStore.isLoading" [is-last-page]="feedStore.isLastPage"></ut-load-more>
  </div>
</div>
`;
